import { staticProducts } from '../data/products'

let initialState = {
	lang: 'ru',
	searchString: '',
	allProducts: [],
}

let rootReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_SEARCH':
			return {
				...state,
				searchString: action.string,
			}

		case 'SET_PRODUCTS':
			return {
				...state,
				allProducts: [...action.products.reverse()],
			}

		default:
			return state
	}
}

export const setSearch = (string) => ({ type: 'SET_SEARCH', string })
export const setAllProducts = (products) => ({ type: 'SET_PRODUCTS', products })

export default rootReducer
